<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Sliders",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Sliders",
            items: [
               {
                  text: "Sliders",
                  active: true,
               },                   
            ],

            listing_length: 10,
            keyword: '',
            status: '',

            sliders: [],
            slider: {
               id: null,
               image : "",
            },

            preview_image: "",
            
            modal_title: "Add Slider",
            button_title: "Save",

            errors: "",
            active_page_url: '',

            activate: false,
            deactivate: false,

            slider_status: {
               id: "",
               status: "",
            },

            from: null,
            to: null,
            total: null,
            pagination: {},
         };
      },
      mounted() {},

      created() {
         this.fetchSliders();
      },
         
      methods: {
         getToken() {
            if (localStorage.getItem('sigofuel_admin')) {
               var sigofuel_admin =  JSON.parse(localStorage.getItem('sigofuel_admin'));
               if(sigofuel_admin.token) {
                  this.token = sigofuel_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchSliders(page_url = null) {

            this.getToken();
            let url = "api/admin/sliders?limit=" + this.listing_length + "&status=" + this.status;

   

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.sliders = responseData.sliders.data;
                  
                  this.pagination = responseData.sliders.links;
                  this.from = responseData.sliders.from;
                  this.to = responseData.sliders.to;
                  this.total = responseData.sliders.total;
               
            })
            .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         }, 

       
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         setFile(e) {
            this.slider.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },
      
         addSlider() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

            if(!this.edit) {
               url = "api/admin/slider/add";
               this.active_page_url = null;
            }    

            formData.append("image", this.slider.image); 
            
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('slider-modal');
                  this.fetchSliders(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         clearForm() {           
            this.modal_title = "Add Slider";
            this.button_title = "Add";
            this.slider.image = "";    
            this.preview_image = "";
            this.edit = false;
            this.errors = {};
         },

         activateSlider(slider) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this slider?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.slider_status.id = slider.id;
                  this.slider_status.status = 1;
                  this.updateSliderStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateSlider(slider) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this slider?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.slider_status.id = slider.id;
                  this.slider_status.status = 2;
                  this.updateSliderStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateSliderStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/slider/status?id=" + this.slider_status.id + "&status=" + this.slider_status.status;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchSliders(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },

         deleteSlider(slider_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this slider?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "api/admin/slider/delete?id=" + slider_id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchSliders(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">                

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.slider-modal variant="primary" class="float-end">Add Slider</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

                        <thead class="table-light">
                           <tr>
                              <th width="2%">SI No</th>
                              <th width="10%">Image</th>    
                              <th width="15%">Created on</th>
                              <th width="10%">Options</th>
                           </tr>
                        </thead>

                        <tbody v-if="Boolean(sliders.length)">
                           <tr v-for="(slider, index) in sliders" :key="slider.id">
                              <td>{{from + index}}</td>  
                              <td>
                                 <img :src="$image_url + slider.image" style="width:100px;" alt="image">
                              </td>
                              <td>{{slider.created_at | formatDateTime}}</td>
                              <td>                                
                                 <b-button variant="danger" class="btn-sm me-2 mb-2" @click="deleteSlider(slider.id)">Delete</b-button>

                                 <b-button v-if="slider.status==1" variant="danger" class="btn-sm mb-2 me-2" @click="deactivateSlider(slider)">Unpublish</b-button>

                                 <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="activateSlider(slider)">Publish</b-button>
                              </td>
                           </tr>
                        </tbody>

                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(sliders.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchSliders(page.url + '&limit='+ listing_length + '&keyword=' + keyword )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->      
                  
                  <!---- modal starts ---->
                  <b-modal ref="slider-modal" id="slider-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addSlider()">                        
                        <div class="row">                            

                           <div class="col-lg-12 mb-3">
                              <label>Image</label>
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg,.gif" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                              <img v-if="preview_image" class="mt-2" :src="preview_image" style="max-width: 200px;">
                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('slider-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
